module.exports = __webpack_public_path__ + "static/melbourne-44dc81cc2d7861a9079cb63dca723d32.png";